import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../core/services/navigation/navigation.service';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  images = [
    { 
      url: "https://ismguide.com/wp-content/uploads/2014/10/slider-bg-globe2-1920x400.jpg",
      text: "Welcome to KiertoaSuomesta" },
    { url: "../../../assets/images/bg-2.jpg", 
      text: "Welcome to KiertoaSuomesta"  },
    { url: "../../../assets/images/bg-3.png", 
      text: "Welcome to KiertoaSuomesta"  }
  ];


  constructor(private navigation: NavigationService) { }

  ngOnInit() {
  }
  buyOrSell(route, buyrSellr) {
    if(localStorage.getItem("token")){
      let route = 'dashboard/create'
      this.navigation.navigateTo(route, '', buyrSellr);
    }
    else{
      this.navigation.navigateTo(route, '', buyrSellr);
    }
  }

}

